<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import TaskFromTemplateForm from './TaskFromTemplateForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { Company } from '@/types';

    const props = defineProps<{
        company: Company;
    }>();

    const form = useForm({
        selected_template: '',
        tasks_deadline: '',
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.dashboard.tasks.create.from-template')"
        :query-key="[QueryKey.DASHBOARD_TASKS, props.company.id]"
        title="dashboards.tasks_add_from_template"
        button-text="dashboards.tasks_create_from_template"
        submit-text="dashboards.tasks_create"
    >
        <TaskFromTemplateForm :form="form" />
    </DialogForm>
</template>
